module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-21.df1f1e9c.png";